export function buildDefaultToast(feature, action) {
    const readable = feature
        .replace(/_/g, " ")
        .replace(/\b\w/g, (l) => l.toUpperCase());

    const titles = {
        view: "Access unavailable",
        create: "Permission required",
        edit: "Edit not permitted",
        delete: "Deletion restricted",
        review: "Review access restricted",
        approve: "Approval restricted",
        email_send: "Email sending restricted",
        generate_bank_advice: "Action restricted",
        create_late: "Permission required",
    };

    const descriptions = {
        view: `Your role does not include access to view ${readable}. Please contact your administrator if you require access.`,
        create: `Creating records in ${readable} requires additional permissions. Contact your administrator if needed.`,
        edit: `Editing records in ${readable} is restricted for your role.`,
        delete: `Deleting records in ${readable} is limited to authorized roles.`,
        review: `Reviewing records in ${readable} is restricted for your role.`,
        approve: `Approving records in ${readable} is restricted for your role.`,
        email_send: `Sending system emails from ${readable} is restricted for your role.`,
        generate_bank_advice: `Generating bank advice in ${readable} requires elevated privileges.`,
        create_late: `Creating late entries in ${readable} requires additional permissions.`,
    };

    return {
        title: titles[action] || "Action not permitted",
        description:
            descriptions[action] ||
            `This action is restricted for your role in ${readable}.`,
    };
}
